export const ACTIVITIES_GET_LIST = '/workflow/dashboard/notificationSearch'
export const PATIENT_PATCH_AGENCY_CASE_MANAGERS =
  '/company/patient/agencyCaseManager'

export const ACTIVITIES_POPOVER_MESSAGE =
  'Not applicable to the previous period, available only for the current periods.'

export const ACTIVITIES_DEFAULT_SORT = {
  sortedColumn: 'date',
  sortedColumnOrder: 'descend'
}

export const NOTIFICATION_SEARCH_PATIENT_STATUS_BY_ACTIVITY = [
  {
    label: 'All',
    title: 'All',
    value: null
  },
  {
    label: 'Open',
    title: 'Open',
    value: 'open'
  },
  {
    label: 'Partially Completed',
    title: 'Partially Completed',
    value: 'partiallyCompleted'
  },
  {
    label: 'Completed',
    title: 'Completed',
    value: 'completed'
  }
]

// not used since EM-30804, but still requires revisit, keeping
export const ACTIVITIES_FILTER_STATUS_LIST = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Open',
    value: 1
  },
  {
    title: 'Missed',
    value: 3
  },
  {
    title: 'Completed',
    value: '2,4'
  }
]

export const ACTIVITIES_TYPE_LIST = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Clinical pathway',
    value: 1
  },
  {
    title: 'Measurement',
    value: 2
  },
  {
    title: 'Medication',
    value: 3
  }
]

export const ACTIVITIES_STATUS_LIST: Map<number, any> = new Map([
  [
    1,
    {
      className: 'status status_open',
      title: 'Open',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'status status_completed',
      title: 'Completed',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'status status_missed',
      title: 'Missed',
      value: 3
    }
  ],
  [
    4,
    {
      className: 'status status_completed',
      title: 'Completed',
      value: 4
    }
  ]
])

export const ACTIVITIES_COMPLIANCE_STATUS: Map<string, any> = new Map([
  [
    'COMPLETED',
    {
      className: 'status-completed',
      title: 'COMPLETED',
      value: 'COMPLETED'
    }
  ],
  [
    'MISSED',
    {
      className: 'status-measurement-closed',
      title: 'MISSED',
      value: 'MISSED'
    }
  ],
  [
    'DYNAMIC',
    {
      className: 'status-measurement-dynamic',
      title: 'DYNAMIC',
      value: 'DYNAMIC'
    }
  ],
  [
    'N/A',
    {
      className: 'status-n-a',
      title: 'N/A',
      value: 'N/A'
    }
  ]
])
